<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form @submit="editCorrectionRequest">
                <div v-if="isAgent" class="row">
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date et heure d’émission de la demande. <span class="text-danger">*</span>
                            </label>
                            <Field name="requested_at" type="date" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrez le date " v-model="formData.requested_at" />
                            <ErrorMessage name="requested_at" class="text-danger" />
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date limite souhaitée pour la prise en compte de la correction. <span
                                    class="text-danger">*</span>
                            </label>
                            <Field name="due_date" type="date" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrez le date " v-model="formData.due_date" />
                            <ErrorMessage name="due_date" class="text-danger" />
                        </div>
                    </div>

                    <div v-if="isAgent" class="col-md-12">
                        <div  class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Représentation structurée <span class="text-danger">*</span>
                            </label>
                            <Field name="fields_concerned" as="textarea" v-model="formData.fields_concerned"
                                class="form-control shadow-none fs-md-15 text-black" />
                            <ErrorMessage name="fields_concerned" class="text-danger" />
                        </div>
                    </div>
                    <!-- <div v-if="isAgent" class="col-md-6">
                        <div  class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Status<span class="text-danger">*</span>
                            </label>
                            <Field name="status">
                                <Multiselect :options="statusOptions" :object="true" :searchable="true" multiple="false"
                                    value-prop="value" track-by="label" label="label" v-model="formData.status"
                                    placeholder="Sélectionner le status" />
                            </Field>
                            <ErrorMessage name="status" class="text-danger" />
                        </div>
                    </div> -->

                    <div class="col-md-12">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Message explicatif adressé au demandeur <span class="text-danger">*</span>
                            </label>
                            <Field name="message_to_requester" as="textarea" v-model="formData.message_to_requester"
                                class="form-control shadow-none fs-md-15 text-black" />
                            <ErrorMessage name="message_to_requester" class="text-danger" />
                        </div>
                    </div>
                    <!-- <div v-if="isTransitaire" class="col-md-12">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Message de réponse <span class="text-danger">*</span>
                            </label>
                            <Field name="response_message" as="textarea" v-model="formData.response_message"
                                class="form-control shadow-none fs-md-15 text-black" />
                            <ErrorMessage name="response_message" class="text-danger" />
                        </div>
                    </div> -->
                    <div v-if="isAgent" class="col-md-6">
                        <div  class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date et heure de la réponse <span class="text-danger">*</span>
                            </label>
                            <Field name="responded_at" type="date" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="" v-model="formData.responded_at" />
                            <ErrorMessage name="responded_at" class="text-danger" />
                        </div>
                    </div>

                    <div v-if="isAgent" class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Référence vers la tâche de validation à l’origine de la demande <span
                                    class="text-danger">*</span>
                            </label>
                            <Field name="validationtasks" v-slot="{ field }">
                                <Multiselect :options="validationtaskOptions" :searchable="true" multiple="false"
                                    value-prop="value" track-by="label" v-bind="field" label="label" :object="true"
                                    v-model="formData.validationtasks" placeholder="Sélectionner la validation Tasks" />
                            </Field>
                            <ErrorMessage name="validationtasks" class="text-danger" />
                        </div>
                    </div>

                    <div v-if="isAgent" class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Référence vers le dossier BESC <span class="text-danger">*</span>
                            </label>
                            <Field name="besc" v-slot="{ field }">
                                <Multiselect :options="bescOptions" :searchable="true" multiple="false" track-by="label"
                                    value-prop="value" label="label" v-bind="field" v-model="formData.besc"
                                    :object="true" placeholder="Sélectionner le besc concerné " />
                            </Field>
                            <ErrorMessage name="besc" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="d-flex align-items-center ">
                            <button
                                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                                type="submit">
                                Modifier
                            </button>
                            <router-link to="/listecorrectionrequests"
                                class=" btn btn-danger transition border-0 lh-1 fw-medium"><i
                                    class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                                <span class="position-relative"></span>Annuler</router-link>
                        </div>
                    </div>

                </div>
            </Form>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, onMounted, nextTick, watch, computed } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { useRoute, useRouter } from "vue-router";
import Multiselect from '@vueform/multiselect'
import ApiService from "../../services/ApiService";
import { error, success } from "../../utils/utils";
import JwtService from "@/services/JwtService";

export default defineComponent({
    name: "EditCorrectionRequest",
    components: { Form, Field, ErrorMessage, Multiselect },
    setup() {
        const router = useRouter();
        const route = useRoute();
        const correctionId = route.params.id

        // VALIDATION
        const EditCorrectionSchema = Yup.object().shape({
            // requested_at: Yup.string().required(),
            // due_date: Yup.string().required(),
            // response_message: Yup.string().required(),
            // status: Yup.string().required(),
            // fields_concerned: Yup.string().required(),
            // message_to_requester: Yup.string().required(),
            // responded_at: Yup.string().required(),
            // validationtasks: Yup.string().required(),
            // user: Yup.string().required(),
        });

        interface Option {
            value: number | string;
            label: string;
        }

        const validationtaskOptions = ref<Option[]>([])
        const bescOptions = ref<Option[]>([])
        const acteurOptions = ref<Option[]>([])
        // const statusOptions = [
        //     { value: 'Ouvert', label: 'Ouvert' },
        //     { value: 'Traité', label: 'Traité' },
        //     { value: 'Annulée', label: 'Annulée' },
        //     { value: 'Expiré', label: 'Expiré' },

        // ]
        const fetchValidationTask = async () => {
            try {
                const user = JwtService.getUser();
                console.log("user:", user);
                if (!user) return error("Utilisateur non connecté");
                const userId = user.userId.replace(/\/+$/, '').trim();
                if (!userId) return error("Utilisateur non connecté");
                const response = await ApiService.get(`/validationts?limit=0&userCreationId=${userId}`);
                const validationTaskData = response.data.data.data;
                validationtaskOptions.value = validationTaskData.map((validationtask) => ({
                    value: validationtask.id,
                    label: `${validationtask.status}`
                }))
            } catch (error) {
                //
            }
        }

        const fetchUser = async () => {
            try {
                const response = await ApiService.get('/users?limit=0');
                const userData = response.data.data.data;
                acteurOptions.value = userData.map((user) => ({
                    value: user.id,
                    label: `${user.nom} ${user.prenom}`
                }))
            } catch (error) {
                //
            }
        }

        const fetchBesc = async () => {
            try {
                const response = await ApiService.get('/bescs?limit=0');
                const bescData = response.data.data.data;
                bescOptions.value = bescData.map((besc) => ({
                    value: besc.id,
                    label: `${besc.refbesc}`
                }))
            } catch (error) {
                //
            }
        }

        const isAgent= computed(() => {
            const user = JwtService.getUser() as any;
            return user?.roles?.includes('Agent') ?? false;
        });
        const isTransitaire= computed(() => {
            const user = JwtService.getUser() as any;
            return user?.roles?.includes('Transitaire')

        })

        interface FormDataType {
            requested_at: string;
            due_date: string;
            responded_at: string;
            // response_message: string;
            fields_concerned: string;
            message_to_requester: string;
            status: { value: string; label: string } | null;
            validationtasks: { value: number; label: string } | null;
            besc: { value: number; label: string } | null;
            user: { value: number; label: string } | null;
        }
        const formData = reactive<FormDataType>({
            requested_at: "",
            due_date: "",
            responded_at: "",
            // response_message: "",
            fields_concerned: "",
            message_to_requester: "",
            status: null,
            validationtasks: null,
            besc: null,
            user: null,
        });

        const formatDate = (dateString: string) => {
            if (!dateString) return "";
            return dateString.split("T")[0];
        };

        const isDateField = (key: string) =>
            ["requested_at", "due_date", "responded_at"].includes(key);

        const getCorrectionRequest = async (id: string) => {
            try {
                const response = await ApiService.get(`/correction/${id}`);
                const donnees = response.data.data;

                // Dates
                formData.requested_at = formatDate(donnees.requested_at);
                formData.due_date = formatDate(donnees.due_date);
                formData.responded_at = formatDate(donnees.responded_at);

                // Textes
                // formData.response_message = donnees.response_message;
                formData.fields_concerned = donnees.fields_concerned;
                formData.message_to_requester = donnees.message_to_requester;
                // formData.response_message = donnees.response_message;
                
                // Status
                // formData.status = statusOptions.find(opt => opt.value === donnees.status) || null;

                // Relations (vérifier que les données existent)
                formData.validationtasks = donnees.validationtasks ? {
                    value: donnees.validationtasks.id,
                    label: `${donnees.validationtasks.status}`
                } : null;

                formData.besc = donnees.besc ? {
                    value: donnees.besc.id,
                    label: `${donnees.besc.refbesc}`
                } : null;

                formData.user = donnees.user ? {
                    value: donnees.user.id,
                    label: `${donnees.user.nom} ${donnees.user.prenom}`
                } : null;

                await nextTick(); // Force re-render Multiselect
            } catch (err: any) {
                console.error("Erreur chargement correction :", err.response || err);
                error("Impossible de charger la demande de correction");
                // router.push("/listecorrectionrequests");
            }
        };
        const editCorrectionRequest = async () => {
            try {
                const payload = {
                    requested_at: formData.requested_at,
                    due_date: formData.due_date,
                    responded_at: formData.responded_at,
                    // response_message: formData.response_message,
                    fields_concerned: formData.fields_concerned,
                    message_to_requester: formData.message_to_requester,
                    status: formData.status?.value,
                    validationtasks_id: formData.validationtasks?.value,
                    besc_id: formData.besc?.value,
                    user_id: formData.user?.value,
                };

                console.log("Payload FINAL :", payload);

                await ApiService.put(`/correction/${correctionId}`, payload);
                success("Modification réussie !");
                router.push("/listecorrectionrequests");
            } catch (err: any) {
                error(err.response?.data?.message || "Échec de la modification");
            }
        };


        watch(
            () => formData.user,
            (newVal) => {
                console.log("Utilisateur changé :", newVal);
            },
            { deep: true }
        );

        watch(
            () => formData.besc,
            (newVal) => {
                console.log("BESC changé :", newVal);
            },
            { deep: true }
        );

        watch(
            () => formData.user,
            (newVal) => {
                console.log("Utilisateur changé :", newVal);
            },
            { deep: true }
        );

        watch(
            () => formData.validationtasks,
            (newVal) => {
                console.log("Validation tasks changé :", newVal);
            },
            { deep: true }
        );
        onMounted(async () => {
            await fetchValidationTask();
            await fetchUser();
            await fetchBesc();
            await getCorrectionRequest(correctionId as string);
        });


        return {
            formData,
            EditCorrectionSchema,
            editCorrectionRequest,
            validationtaskOptions,
            bescOptions,
            acteurOptions,
            // statusOptions, 
            isAgent, isTransitaire


        };
    }
});
</script>
